<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            load: false,
            amount: 0,
            currency_id: 0,
            contract_dues_id: 0,
            contract: {
                'contract_id': 0,
                'id': 0,
                'currency_id': 0,
            },
            bills: [],
            billsData: [],
        }
    },
    methods: {
        onChangeImpuesto(itemBase, tipo) {
            const factura = this.billsData[itemBase.bill_id];
            if (factura && factura.type == 1) {
                this.bills.forEach(item => {
                    if (item.bill_id === itemBase.bill_id) {
                        item[tipo] = itemBase[tipo];
                    }
                });
            }
        },
        addItem() {
            let item = {
                'id': '',
                'description': '',
                'bill_id': 0,
                'final_amount': 0,
                'discount': 0,
                'iva': 0,
                'ieps': 0,
                'isr_ret': 0,
                'iva_ret': 0,
                'total': 0
            };
            this.bills.push(item);
        },
        calcularTotales(item) {
            const montoBase = parseFloat(item.final_amount) || 0;
            const descuento = parseFloat(item.discount) || 0;

            const base = montoBase - descuento;

            const iva = item.iva ? base * 0.16 : 0;
            const ieps = item.ieps ? base * 0.08 : 0;
            const isrRet = item.isr_ret ? base * 0.10 : 0;
            const ivaRet = item.iva_ret ? base * 0.106666 : 0;

            // Calcular el total
            const total = base + iva + ieps - isrRet - ivaRet;


            return {
                iva,
                ieps,
                isrRet,
                ivaRet,
                total
            };
        },
        closedModal() {
            this.load = false;
            this.errors = {};
            this.send = false;
            this.amount = 0;
            this.contract = {};
            this.bills = [];
            this.billsData = [];
            this.$modal.hide('addCreateBillExternalPay');
        },
        addBillData(data = {
            name: 'Factura ' + this.billsData.length,
            billing_data_id: this.catalogue.companies_buildings[0].id,
            type: 1,
            contract_dues_id: this.contract.id,
            currency_id: this.contract.currency_id,
            exchange_rate_bill: 0,
        }) {
            this.billsData.push(data);
        },
        async triggerSave() {
            this.send = true;
            const data_form = new FormData();

            data_form.append('contract', JSON.stringify(this.contract));
            data_form.append('bills', JSON.stringify(this.bills));
            data_form.append('bills_data', JSON.stringify(this.billsData));
            data_form.append('currency_id', this.currency_id);
            data_form.append('amount', this.totalGeneral);
            data_form.append('contract_dues_id', this.contract_dues_id);

            let _endpoint = '/payment_bill_external';


            try {
                let { data } = await request.post(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-contract_dues');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    const outerMessage = error.response.data.message;
                    const jsonString = outerMessage.split('Unable to create Invoice: ')[1];
                    const parsed = JSON.parse(jsonString);
                    let innerMessage = parsed.message;
                    alert(innerMessage);
                    this.errors = await this.errorNotification(error);
                }
                this.send = false;
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    mounted() {
        this.catalogue.getCurrencies();
    },
    created() {
        Event.$on("event-show-addCreateBillExternalPays", async (contract) => {
            console.log(contract);
            this.contract_dues_id = contract.id;
            this.load = true;
            this.$modal.show('addCreateBillExternalPay');
            console.log(contract);
            this.contract.contract_id = contract.contract_id;
            this.contract.id = contract.id;
            this.contract.currency_id = contract.contract.currency_id;
            // await this.catalogue.getBillingDataUser(contract.contract.user_id);
            await this.catalogue.get_companies_buildings(contract.contract.building_id);

            let items = [];
            let bills = false;
            if (contract.group_type == "extras") {
                contract.due_items_extras.forEach(_item => {
                    if (_item.item_bill == null) {
                        items.push({
                            'id': _item.id,
                            'description': _item.description,
                            'bill_id': 0,
                            'final_amount': _item.final_amount,
                            'type': _item.type,
                            'item_id': _item.item_id,
                            'discount': 0,
                            'iva': 0,
                            'ieps': 0,
                            'isr_ret': 0,
                            'iva_ret': 0,
                            'total': 0
                        });

                    } else {
                        bills = true;
                    }
                });
            } else if (contract.group_type == "rent") {
                contract.due_items_rent_only.forEach(_item => {
                    if (_item.item_bill == null) {
                        items.push({
                            'id': _item.id,
                            'description': _item.description,
                            'bill_id': 0,
                            'final_amount': _item.final_amount,
                            'type': _item.type,
                            'item_id': _item.item_id,
                            'discount': 0,
                            'iva': 0,
                            'ieps': 0,
                            'isr_ret': 0,
                            'iva_ret': 0,
                            'total': 0
                        });

                    } else {
                        bills = true;
                    }
                });
            }

            if (!bills && contract.contract.rules_billing.length > 0 && contract.group_type == "rent") {
                contract.contract.rules_billing.forEach((rule, indexR) => {
                    console.log(rule);
                    this.addBillData({
                        name: rule.name,
                        billing_data_id: rule.billing_data_id,
                        type: parseInt(rule.type),
                        contract_dues_id: contract.id,
                        currency_id: rule.currency_id,
                        exchange_rate_bill: 0,
                    });

                    // console.log('rule');
                    // console.log(rule.rules_items);
                    if (rule.rules_items.length > 0) {
                        rule.rules_items.forEach(item => {
                            // console.log('item');
                            // console.log(item);
                            // console.log(items);
                            const idx = items.findIndex(it => it.item_id === item.item_id && it.type === parseInt(item.type));
                            // console.log(idx);
                            if (idx > -1) {
                                items[idx].bill_id = indexR;
                                items[idx].discount = item.discount;
                                items[idx].iva = item.iva;
                                items[idx].ieps = item.ieps;
                                items[idx].isr_ret = item.isr_ret;
                                items[idx].iva_ret = item.iva_ret;
                            }
                        });
                    }
                });
            } else {
                this.addBillData({
                    name: 'Factura principal',
                    billing_data_id: this.catalogue.companies_buildings[0].id,
                    type: 1,
                    contract_dues_id: contract.id,
                    currency_id: this.contract.currency_id,
                    exchange_rate_bill: 0,
                });

            }

            this.bills = items;
            this.load = false;
        });
    },
    watch: {

    },
    computed: {

        totalsByBill() {
            let result = {};

            this.bills.forEach(item => {
                const billId = item.bill_id;
                console.log(billId);
                if (!result[billId]) {
                    result[billId] = 0;
                }

                let multiply = 1;
                let changeDate = this.billsData[item.bill_id];
                if (changeDate.currency_id == 2) {
                    multiply = changeDate.exchange_rate_bill;
                }

                result[billId] += this.calcularTotales(item).total * multiply;
            });

            console.log(result);
            return result;
        },
        totalGeneral() {
            return Object.values(this.totalsByBill).reduce((acc, val) => acc + val, 0);
        },
        hasCurrency1() {
            return this.billsData.some(bill => bill.currency_id === 2);
        }
    }
}
</script>
<template>
    <modal name="addCreateBillExternalPay" :width="'80%'" :maxHeight="300" :height="'auto'"
        v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>

        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Pago de adeudos</h5>
        </div>
        <div class="modal-body">
            <div class="row" v-if="load">
                <div class="col-md-12 text-center">
                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                    <h5>Cargando</h5>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12 mt-3">
                    <div class="row" v-for="(bill, index) in billsData" :key="index">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body p-0">
                                    <!-- tipo de cambio -->
                                    <div class="row" v-if="contract.currency_id == 2">
                                        <div :class="bill.currency_id == 2 ? 'col-md-6' : 'col-md-12'">
                                            <label v-if="contract.currency_id == 2">Moneda : </label><br>
                                            <select class="form-control" v-model="bill.currency_id">
                                                <option :value="currency.id"
                                                    v-for="(currency, index) in catalogue.currencies" :key="index">
                                                    {{ currency.name }}
                                                </option>
                                            </select>
                                            <div v-if="errors && errors.currency_id" class="text-danger">
                                                {{ errors.currency_id[0] }}
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="bill.currency_id == 2">
                                            <label>Tipo de cambio</label>
                                            <money class="form-control from-control-sm"
                                                v-model="bill.exchange_rate_bill"></money>
                                            <div v-if="errors && errors.exchange_rate_bill" class="text-danger">
                                                {{ errors.exchange_rate_bill[0] }}
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <hr>
                                        </div>
                                    </div>
                                    <div class="row" v-show="item.bill_id == index" v-for="(item, index_item) in bills"
                                        :key="index_item">
                                        <div class="col-md-12">
                                            <label>Item</label>
                                            <br>
                                            <span v-if="item.id">{{ item.description }}</span>
                                            <hr>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label>Subtotal</label>
                                                </div>
                                                <div class="col-6 text-right">
                                                    {{ item.final_amount | toCurrency }}
                                                </div>

                                                <!-- Descuento -->
                                                <div class="col-6" v-if="item.discount > 0">
                                                    <label>Descuento</label>
                                                </div>
                                                <div class="col-6 text-right" v-if="item.discount > 0">
                                                    {{ item.discount | toCurrency }}
                                                </div>

                                                <!-- IVA -->
                                                <div class="col-6" v-if="item.iva">
                                                    <label>IVA (16%)</label>
                                                </div>
                                                <div class="col-6 text-right" v-if="item.iva">
                                                    {{ calcularTotales(item).iva | toCurrency }}
                                                </div>

                                                <!-- IEPS -->
                                                <div class="col-6" v-if="item.ieps">
                                                    <label>IEPS (8%)</label>
                                                </div>
                                                <div class="col-6 text-right" v-if="item.ieps">
                                                    {{ calcularTotales(item).ieps | toCurrency }}
                                                </div>

                                                <!-- ISR Retenido -->
                                                <div class="col-6" v-if="item.isr_ret">
                                                    <label>ISR Ret. (10%)</label>
                                                </div>
                                                <div class="col-6 text-right" v-if="item.isr_ret">
                                                    - {{ calcularTotales(item).isrRet | toCurrency }}
                                                </div>

                                                <!-- IVA Retenido -->
                                                <div class="col-6" v-if="item.iva_ret">
                                                    <label>IVA Ret. (10.666%)</label>
                                                </div>
                                                <div class="col-6 text-right" v-if="item.iva_ret">
                                                    - {{ calcularTotales(item).ivaRet | toCurrency }}
                                                </div>

                                                <div class="col-12">
                                                    <hr>
                                                </div>

                                                <!-- Total -->
                                                <div class="col-6">
                                                    <label>Total</label>
                                                </div>
                                                <div class="col-6 text-right">
                                                    {{ calcularTotales(item).total | toCurrency }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <hr>
                                        </div>
                                        <!-- Subtotal -->
                                        <div class="col-6">
                                            <label>Total general:</label>
                                        </div>
                                        <div class="col-6 text-right">
                                            {{ totalsByBill[index] | toCurrency }}
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mt-3">
                    <hr>
                </div>
                <div class="col-md-6 mt-3">
                    <label>Total general:</label>
                </div>
                <div class="col-md-6 mt-3 text-right">
                    {{ totalGeneral | toCurrency }}
                </div>
            </div>

            <div class="row">

                <div class="col-md-12 mt-3">

                    <button :disabled="send" type="button" @click="triggerSave()"
                        class="btn float-right btn-outline-success">
                        <span v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Marcar como pagado
                        </span>
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>

            </div>
        </div>
    </modal>
</template>